module.exports = __webpack_public_path__ + "static/media/advisory.711ef72d.svg";